module.exports = function getResource(label, vars = []) {
    let resources = {
        pinchAndZoom: 'Pincer et agrandir',
        pinchToZoom: 'Pincer pour agrandir'
    };

    return resources[label];
};
